const testIds: Record<string, string> = {
  DISCOVERY_APPLICATIONCARD_CONTAINER_SELECTBUTTON:
    'integrations-applicationCard-container-selectButton',
  DISCOVERY_APPLICATIONCARD_SUCCESS_IMPORT_BUTTON:
    'integrations-application-success-import-button',
  DISCOVERY_APPLICATIONCARD_SUCCESS_IMPORT_SKIP_LINK:
    'integrations-application-success-import-skip-link',
  DISCOVERY_APPLICATIONCARD_SELECT_BUTTON:
    'integrations-application-card-container-select-button',
  DISCOVERY_APPLICATIONCARD_CREATE_CONNECTION_SAVE_BUTTON:
    'integrations-application-card-createConnection-save-button',
  DISCOVERY_APPLICATIONCARD_CREATE_CONNECTION_BACK_BUTTON:
    'integration-application-card-createConnection-back-button',
  DISCOVERY_EXISTING_CONNECTION_DROPDOWN:
    'integrations-discovery-existing-connection-dropdown',
  DISCOVERY_EXISTING_CONNECTION_CREATE_NEW_CONNECTION:
    'integrations-discovery-existing-connection-createNewConnection-button',
  DISCOVERY_EXISTING_CONNECTION_USE_THIS_CONNECTION:
    'integrations-discovery-existing-connection-use-this-connection-button',
  DISCOVERY_FORM_BUILDER_INPUT_FIELD: 'integration-form-builder-input-field',
  DISCOVERY_INTEGRATION_ERROR_PAGE_RELOAD_BUTTON:
    'intergration-error-page-reload-button',
  SCHEDULING_CONTAINER: 'integrations-scheduling-container',
  SCHEDULING_ALERT_BANNER: 'integrations-scheduling-alert-banner',
  SCHEDULING_BODY: 'integrations-scheduling-body',
  SCHEDULING_FOOTER: 'integrations-scheduling-footer',
  SCHEDULING_FOOTER_SAVE_BUTTON: 'integrations-scheduling-footer-save-button',
  SCHEDULING_FREQUENCY_SELECTOR: 'integrations-scheduling-frequency-selector',
  SCHEDULING_INTERVAL_INPUT: 'integrations-scheduling-interval-input',
  WEEKLY_REPEAT_SELECTOR: 'integrations-weekly-repeat-selector',
  WEEKLY_REPEAT_CHIPS: 'integrations-weekly-repeat-chips',
  CMDB_HEADER_CONTAINER: 'integrations-cmdb-header-container',
  CMDB_HEADER_ALERT_BANNER: 'integrations-cmdb-header-alert-banner',
  CMDB_HEADER_BACK_BUTTON: 'integrations-cmdb-header-back-button',
  CMDB_HEADER_IMAGE: 'integrations-cmdb-header-image',
  CMDB_HEADER_RUN_MANUALLY_BUTTON:
    'integrations-cmdb-header-run-manually-button',
  CMDB_HEADER_MORE_MENU: 'integrations-cmdb-header-more-menu',
  CMDB_HEADER_ENABLE_BUTTON: 'integrations-cmdb-header-enable-button',
  CMDB_HEADER_IMPORT_MODAL: 'integrations-cmdb-header-import-modal',
  CONNECTION_SETTINGS_CONTAINER: 'integrations-connection-settings-container',
  CONNECTION_SETTINGS_ALERT_BANNER:
    'integrations-connection-settings-alert-banner',
  CONNECTION_SETTINGS_LOADER: 'integrations-connection-settings-loader',
  CONNECTION_SETTINGS_FORM: 'integrations-connection-settings-form',
  CONNECTION_SETTINGS_FOOTER: 'integrations-connection-settings-footer',
  CONNECTION_SETTINGS_SAVE_BUTTON:
    'integrations-connection-settings-save-button',
  ATTRIBUTE_MAPPINGS_CONTAINER: 'integrations-attribute-mappings-container',
  ATTRIBUTE_MAPPINGS_ALERT_BANNER:
    'integrations-attribute-mappings-alert-banner',
  ATTRIBUTE_MAPPINGS_WRAPPER: 'integrations-attribute-mappings-wrapper',
  ATTRIBUTE_MAPPINGS_GRID: 'integrations-attribute-mappings-grid',
  ATTRIBUTE_MAPPINGS_ADD_BUTTON: 'integrations-attribute-mappings-add-button',
  ATTRIBUTE_MAPPINGS_SAVE_BUTTON: 'integrations-attribute-mappings-save-button',
  ATTRIBUTE_MAPPINGS_FOOTER: 'integrations-attribute-mappings-footer',
  ATTRIBUTE_ROW: 'integrations-attribute-row',
  ATTRIBUTE_ROW_DELETE_BUTTON: 'integrations-attribute-row-delete-button',
  ATTRIBUTE_DROPDOWN: 'integrations-attribute-dropdown',
  ATTRIBUTE_DROPDOWN_SEARCH: 'integrations-attribute-dropdown-search',
  ATTRIBUTE_DROPDOWN_OPTIONS: 'integrations-attribute-dropdown-options',
  ATTRIBUTE_DROPDOWN_OPTION: 'integrations-attribute-dropdown-option',
  MANAGE_CMDB_DISCOVERED_APPS_CONTAINER:
    'integrations-manage-cmdb-discovered-apps-container',
  MANAGE_CMDB_DISCOVERED_APPS_LOADER:
    'integrations-manage-cmdb-discovered-apps-loader',
  MANAGE_CMDB_DISCOVERED_APPS_ALERT_BANNER:
    'integrations-manage-cmdb-discovered-apps-alert-banner',
  MANAGE_CMDB_DISCOVERED_APPS_PAGE_HEADER:
    'integrations-manage-cmdb-discovered-apps-page-header',
  MANAGE_CMDB_DISCOVERED_APPS_TAB_GROUP:
    'integrations-manage-cmdb-discovered-apps-tab-group',
  MANAGE_CMDB_DISCOVERED_APPS_MAIN_CONTENT:
    'integrations-manage-cmdb-discovered-apps-main-content',
  MANAGE_CMDB_DISCOVERED_APPS_DISCARD_MODAL:
    'integrations-manage-cmdb-discovered-apps-discard-modal',
  DISCOVERY_INTEGRATION_EXISTING_CONNECTION_TEST_CONNECTION_FAILED:
    'integration-existing-test-connection-failed-close',
};

export default testIds;
